import { PenNib, ArrowSquareOut } from "@phosphor-icons/react";
import { Button } from "../../ui/button";
import { ConfirmationsVault, BillingCenter, ReferralWidget, SecurityPane } from "../PortalSections";
import { BackupCodes } from "../../BackupCodes";
import { PrivacyPane } from "../PrivacyPane";

// Billing & Engagements tab: e-signature envelopes, filing confirmations vault,
// referrals, invoices, security posture (device log + backup codes + privacy).
export default function BillingTab({ data, extras, setFinalEng }) {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-testid="portal-panel-billing">
      <div className="space-y-6">
        <div className="rounded-lg border border-zinc-200 bg-white p-5">
          <h3 className="text-sm font-medium text-zinc-900 mb-3">E-signature board</h3>
          {(data?.envelopes || []).map((env) => (
            <div key={env.id} data-testid={`envelope-${env.id}`} className="flex items-center justify-between py-2 border-b border-zinc-100 last:border-0">
              <div>
                <p className="text-sm text-zinc-800">{env.title}</p>
                <p className="text-[10px] text-zinc-400">
                  {env.status === "signed"
                    ? `Signed ${new Date(env.signed_at).toLocaleDateString()}`
                    : env.sign_method === "drake_portals" ? "Sign via Drake Portals — your firm confirms once notified" : "Awaiting your signature"}
                </p>
              </div>
              {env.status === "pending" ? (
                env.sign_method === "drake_portals" ? (
                  <a data-testid={`drake-link-${env.id}`} href={env.external_link} target="_blank" rel="noreferrer"
                    className="flex items-center gap-1 text-xs text-zinc-700 border border-zinc-200 rounded-md px-2.5 py-1.5 hover:bg-zinc-50 transition-colors duration-150">
                    <ArrowSquareOut size={12} /> Sign in Drake Portals
                  </a>
                ) : (
                  <Button data-testid={`sign-btn-${env.id}`} size="sm" className="h-7 text-xs" onClick={() => setFinalEng(env.engagement_id)}>
                    <PenNib size={13} className="mr-1" /> Review & sign
                  </Button>
                )
              ) : (
                <span className="text-[10px] bg-emerald-50 text-emerald-700 border border-emerald-200 rounded-sm px-2 py-1">SIGNED</span>
              )}
            </div>
          ))}
          {data?.envelopes?.length === 0 && <p className="text-xs text-zinc-400 italic">No signatures needed.</p>}
        </div>
        <ConfirmationsVault confirmations={extras?.confirmations} />
        <ReferralWidget referrals={extras?.referrals} />
      </div>
      <div className="space-y-6">
        <BillingCenter invoices={extras?.invoices} />
        <SecurityPane deviceLog={extras?.device_log} />
        <BackupCodes />
        <PrivacyPane />
      </div>
    </div>
  );
}
